import { render, staticRenderFns } from "./ThirdPartyAdd.vue?vue&type=template&id=66d49f25&scoped=true&"
import script from "./ThirdPartyAdd.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d49f25",
  null
  
)

export default component.exports